import { useState } from "react";
import Page from "../../components/Page";
import FormGeneratorSection from "../../components/Survey/FormGeneratorSection";

const FormGeneratorPage = () => {

    return (
        <>
            <Page>
                <FormGeneratorSection />
            </Page>
        </>
    )
}

export default FormGeneratorPage